import { takeLatest, call, put, all, select } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, CadastrarUsuarioMainframeRequest } from './types';

// ACTIONS
import {
	cadastrarUsuarioMainframeSuccess,
	cadastrarUsuarioMainframeFailure,
} from './actions';

function* cadastrarUsuarioMainframe(request: ReducerAction) {
	const { payload }: { payload: CadastrarUsuarioMainframeRequest } = request;
	const { id, ...rest } = payload;

	const token: string = yield select(state => state.user.token.data);

	const response: ApiResponse = yield call(
		postApi,
		token,
		PATH_SGU_API,
		`usuarios-mainframe`,
		rest,
		{ idUsuarioAutenticado: id },
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastrarUsuarioMainframeSuccess(response));
	} else {
		yield put(cadastrarUsuarioMainframeFailure());
	}
}

export default all([
	takeLatest(
		Types.CADASTRAR_USUARIO_MAINFRAME_REQUEST,
		cadastrarUsuarioMainframe,
	),
]);
